export default __webpack_public_path__ + "static/media/new-people.4a809da2.svg";